import React from 'react';
import Navbar from '../Components/Landingpage/Navbar';
import Footer from '../Components/Landingpage/Footer';
import BackToTop from '../Components/Landingpage/BackToTop';
import { 
  getCompanyName, 
  getEmail, 
  getPhone, 
  getPhoneLink, 
  getOperatingHours, 
  getSocialMedia 
} from '../data/companyDetails';

const ContactUs = () => {
  const companyName = getCompanyName();
  const email = getEmail();
  const phone = getPhone();
  const phoneLink = getPhoneLink();
  const operatingHours = getOperatingHours();
  const socialMedia = getSocialMedia();

  return (
    <>
      <Navbar />
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h1 className="display-4 mb-4 text-primary">Contact Us</h1>
              <p className="lead">
                We'd love to hear from you! Whether you have a question, feedback, or need support, our team is here to assist you.
              </p>
            </div>
          </div>
          
          <div className="row g-5">
            <div className="col-lg-6">
              <h3 className="text-primary mb-4 border-bottom pb-2">Get In Touch</h3>
              <form>
                <div className="row g-3">
                  <div className="col-md-6">
                    <input type="text" className="form-control" placeholder="Your Name" required />
                  </div>
                  <div className="col-md-6">
                    <input type="email" className="form-control" placeholder="Your Email" required />
                  </div>
                  <div className="col-12">
                    <input type="text" className="form-control" placeholder="Subject" required />
                  </div>
                  <div className="col-12">
                    <textarea className="form-control" rows="5" placeholder="Your Message" required></textarea>
                  </div>
                  <div className="col-12">
                    <button type="submit" className="btn btn-primary py-3 px-5">Send Message</button>
                  </div>
                </div>
              </form>

              <div className="mt-5">
                <h4 className="text-secondary mb-3">Support Requests</h4>
                <div className="bg-light p-4 rounded">
                  <p className="mb-3">For technical assistance or issues related to your subscription or purchases, please include the following details in your email:</p>
                  <ul className="list-unstyled">
                    <li className="mb-2"><i className="fas fa-user text-primary me-2"></i> Your name</li>
                    <li className="mb-2"><i className="fas fa-receipt text-primary me-2"></i> Order or subscription ID</li>
                    <li className="mb-2"><i className="fas fa-comment-alt text-primary me-2"></i> Description of the issue</li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="col-lg-6">
              <h3 className="text-primary mb-4 border-bottom pb-2">Contact Details</h3>
              
              <div className="mb-4">
                <div className="bg-primary text-white p-4 rounded mb-4">
                  <h5 className="text-white mb-2">
                    <i className="fas fa-building me-2"></i>
                    Company Name
                  </h5>
                  <p className="mb-0">{companyName}</p>
                </div>
              </div>

              <div className="d-flex align-items-center mb-4">
                <i className="fas fa-envelope fa-2x text-primary me-3"></i>
                <div>
                  <h5>Email</h5>
                  <p className="mb-0">
                    <a href={`mailto:${email}`} className="text-primary">{email}</a>
                  </p>
                </div>
              </div>
              
              <div className="d-flex align-items-center mb-4">
                <i className="fas fa-phone fa-2x text-primary me-3"></i>
                <div>
                  <h5>Phone</h5>
                  <p className="mb-0">
                    <a href={phoneLink} className="text-primary">{phone}</a>
                  </p>
                </div>
              </div>
              
              <div className="mb-5">
                <h4 className="text-secondary mb-3">
                  <i className="fas fa-clock text-primary me-2"></i>
                  Operating Hours
                </h4>
                <div className="bg-light p-4 rounded">
                  <div className="row">
                    <div className="col-12 mb-3">
                      <p className="mb-1">
                        <i className="fas fa-calendar-week text-success me-2"></i>
                        <strong>{operatingHours.weekdays}</strong>
                      </p>
                      <p className="mb-1">
                        <i className="fas fa-calendar-day text-warning me-2"></i>
                        <strong>{operatingHours.saturday}</strong>
                      </p>
                      <p className="mb-0">
                        <i className="fas fa-calendar-times text-danger me-2"></i>
                        <strong>{operatingHours.sunday}</strong>
                      </p>
                      <div className="alert alert-info mt-3 mb-0" role="alert">
                        <i className="fas fa-headset me-2"></i>
                        <small><strong>{operatingHours.customerCare}</strong></small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <h4 className="text-secondary mb-3">
                  <i className="fas fa-share-alt text-primary me-2"></i>
                  Connect With Us
                </h4>
                <p className="mb-3">Stay updated with the latest content and offers:</p>
                {/* <div className="d-flex gap-3">
                  <a href={socialMedia.facebook} className="btn btn-primary btn-square rounded-circle">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href={socialMedia.instagram} className="btn btn-primary btn-square rounded-circle">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href={socialMedia.twitter} className="btn btn-primary btn-square rounded-circle">
                    <i className="fab fa-twitter"></i>
                  </a>
                </div> */}
              </div>

              <div className="bg-success bg-opacity-10 p-4 rounded border border-success">
                <p className="mb-0 text-center">
                  <i className="fas fa-heart text-success me-2"></i>
                  <strong>We value your feedback and strive to provide the best service possible. Thank you for choosing {companyName}.</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <BackToTop />
    </>
  );
};

export default ContactUs;
